import React from "react";
import { Link } from "react-router-dom";

export default function MarketingFooter() {
  return (
    <footer className="border-t border-stone-200 bg-white">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-8">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <div className="flex h-8 w-8 items-center justify-center rounded-md bg-slate-950 text-white">
                <span className="font-display text-sm font-bold">A</span>
              </div>
              <div>
                <div className="font-display text-lg font-bold text-slate-950">ATLAS™</div>
                <div className="label-mono !text-[9px]">The IXL Business Pro</div>
              </div>
            </div>
            <p className="mt-6 max-w-md text-sm leading-relaxed text-stone-600">
              The AI Operating System for Entrepreneurial Ecosystems. Transform entrepreneurs into stronger businesses.
              Transform programs into measurable economic impact.
            </p>
          </div>
          <div>
            <div className="label-mono mb-4">Product</div>
            <ul className="space-y-3 text-sm text-stone-700">
              <li><a href="/#product" className="hover:text-slate-950">Capabilities</a></li>
              <li><a href="/#outcomes" className="hover:text-slate-950">Outcomes</a></li>
              <li><a href="/#pricing" className="hover:text-slate-950">Pricing</a></li>
              <li><Link to="/capital-raising" className="hover:text-slate-950">Capital Raising</Link></li>
            </ul>
          </div>
          <div>
            <div className="label-mono mb-4">Get Started</div>
            <ul className="space-y-3 text-sm text-stone-700">
              <li><Link to="/request-demo" className="hover:text-slate-950">Request a Demo</Link></li>
              <li><Link to="/request-demo?type=discovery" className="hover:text-slate-950">Discovery Call</Link></li>
              <li><Link to="/login" className="hover:text-slate-950">Sign in</Link></li>
              <li><Link to="/signup" className="hover:text-slate-950">Create Account</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-stone-200 pt-8 md:flex-row md:items-center">
          <div className="text-xs text-stone-500">© {new Date().getFullYear()} ATLAS™ | The IXL Business Pro. All rights reserved.</div>
          <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-stone-400">
            Powered by AIH LLC
          </div>
        </div>
      </div>
    </footer>
  );
}
